import { render, staticRenderFns } from "./PolicyStakeholders.vue?vue&type=template&id=bd47a8ba"
import script from "./PolicyStakeholders.vue?vue&type=script&lang=js"
export * from "./PolicyStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports